export { PrimeiroPassoComponent } from './primeiro-passo/primeiro-passo.component';
export { SegundoPassoComponent } from './segundo-passo/segundo-passo.component';
export { TerceiroPassoComponent } from './terceiro-passo/terceiro-passo.component';
